import { Fragment } from 'react';
import { Link } from 'react-router-dom';

/**
 * Trilha de navegacao "Parametrizacao / ..." do OnPoint (PAR-006).
 *
 * Fica no modulo porque so a parametrizacao a usa hoje. Se outro modulo precisar,
 * ela sobe para `shared/ui` como componente comum.
 */
export function Trilha({
  itens,
  atual,
}: {
  itens: { rotulo: string; para: string }[];
  atual: string;
}) {
  return (
    <nav aria-label="Trilha de navegacao" className="text-xs text-ink-500">
      <ol className="flex flex-wrap items-center gap-1">
        {itens.map((item) => (
          <Fragment key={item.para}>
            <li>
              <Link
                to={item.para}
                className="font-medium text-brand-700 hover:underline"
              >
                {item.rotulo}
              </Link>
            </li>
            <li aria-hidden="true">/</li>
          </Fragment>
        ))}
        <li aria-current="page" className="text-ink-700">
          {atual}
        </li>
      </ol>
    </nav>
  );
}
